import { render, staticRenderFns } from "./BlacklistedPhonesEditor.vue?vue&type=template&id=029425aa&scoped=true&"
import script from "./BlacklistedPhonesEditor.vue?vue&type=script&lang=js&"
export * from "./BlacklistedPhonesEditor.vue?vue&type=script&lang=js&"
import style0 from "./BlacklistedPhonesEditor.vue?vue&type=style&index=0&id=029425aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029425aa",
  null
  
)

component.options.__file = "BlacklistedPhonesEditor.vue"
export default component.exports